import { render } from "./BuyTravelPass.vue?vue&type=template&id=8b01864e&scoped=true&lang=pug"
import script from "./BuyTravelPass.vue?vue&type=script&lang=ts"
export * from "./BuyTravelPass.vue?vue&type=script&lang=ts"

import "./BuyTravelPass.vue?vue&type=style&index=0&id=8b01864e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8b01864e"

export default script